export default "__VITE_ASSET__xnkgv2ta__"